import { dayOfWeek } from '@/enums/dayOfWeek';

export class schedulingItem {
	
	constructor() {
		this.dayOfWeeks = [];
		this.executeTimes = [];				
	}
	dayOfWeeks: dayOfWeek[];
	executeTimes: string[];
}
